/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Stato di una graduatoria-istanza nel suo ciclo di vita
 */
export enum StatoGraduatoria {

    BOZZA = 'BOZZA',

    CONFERMATA = 'CONFERMATA',

    SUPERSEDED = 'SUPERSEDED',

    ANNULLATA = 'ANNULLATA'
}

